import React from 'react'

import './Modal.sass'

export const Modal = {
  Dialog: ({ children, show }) => {
    const style = {display: (show ? 'block' : 'none')}
    return (
      <div className='modal' style={style}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {children}
          </div>
        </div>
      </div>
    )
  },
  Header: ({ children, title, handleClose }) => (
    <div className="modal-header">
      {children}
      {title && <h5 className="modal-title">{title}</h5>}
      {handleClose && 
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  ),
  Body: ({ children }) => (
    <div className="modal-body">
      {children}
    </div>
  ),
  Footer: ({ children }) => (
    <div className="modal-footer">
      {children}
    </div>
  ),
}
